import React, { useCallback, useState } from "react";
import { RefreshContext } from "./RefreshContext";
const RefreshProvider=({children})=>{
    const [refreshCallback, setRefreshCallback]=useState(null);
    const handleRefresh=useCallback(()=>{
        if(refreshCallback){
            refreshCallback();
        }
    }, [refreshCallback]);
    const value={
        setRefreshCallback, handleRefresh
    };
    return (
        <RefreshContext.Provider value={value}>
            {children}
        </RefreshContext.Provider>
    )
}
export default RefreshProvider;